module.exports = __webpack_public_path__ + "img/icon@2x (3).1727ed9a.png";